import type { APICategoryAttributes } from "~~/shared/types/category";
import type { ApiResponse } from "~~/server/utils/apiResponse";

export const useCategoryFilters = (slug?: string) => {
    if (!slug) return { data: ref<APICategoryAttributes[] | null>(null), pending: ref(false), refresh: () => {} };

    const key = `northland:categories-filters:${slug}`;

    return useAsyncData<APICategoryAttributes[] | null>(
        key,
        async () => {
            const res = await smartFetch<ApiResponse<APICategoryAttributes[]>>(`/v1/categories/${slug}/filters`, { baseTarget: "local" });
            return "data" in res ? res.data ?? null : null;
        }
    );
};
